import { clsx } from "clsx";
import type { ReactNode } from "preact/compat";
import classes from "./icon-tagged-text.module.css";

type IconTaggedTextProps = {
	readonly icon: ReactNode;
	readonly prefixText?: string;
	readonly text: string;
	readonly isOpen?: boolean;
};

function IconTaggedText({
	isOpen,
	icon,
	prefixText,
	text,
}: IconTaggedTextProps) {
	return (
		<div
			className={clsx(
				classes["icon-tagged-text"],
				isOpen && classes["icon-tagged-text-open"],
			)}
		>
			<div className={classes["background"]} />
			<div className={classes["icon"]}>{icon}</div>
			<div className={classes["text-content"]}>
				{prefixText && (
					<div className={classes["prefix-text"]}>{prefixText}</div>
				)}
				<div>{text}</div>
			</div>
		</div>
	);
}

export default IconTaggedText;
